"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icons_1 = require("office-ui-fabric-react/lib/Icons");
var microsoftTeams = require("@microsoft/teams-js");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var serventias_api_1 = require("../../api/serventias-api");
var config_api_1 = require("../../api/config-api");
require("./../form-balcao-virtual/form-balcao-virtual.scss");
var data_1 = require("../../constants/data");
var loaderFormBalcaoVirtual_1 = require("../loaders/loaderFormBalcaoVirtual");
var common_helper_1 = require("../../helpers/common-helper");
var image_helper_1 = require("../../helpers/image-helper");
var react_i18next_1 = require("react-i18next");
var _ = require('lodash');
var FormBalcaoVirtual = /** @class */ (function (_super) {
    __extends(FormBalcaoVirtual, _super);
    function FormBalcaoVirtual(props) {
        var _this = _super.call(this, props) || this;
        _this.serventiaId = null;
        /**
         * Parse week days
         * */
        _this.getDaysOfWeek = function () {
            return [
                { "header": _this.localize("SegundaFeira"), "key": "segunda-feira" },
                { "header": _this.localize("TercaFeira"), "key": "terça-feira" },
                { "header": _this.localize("QuartaFeira"), "key": "quarta-feira" },
                { "header": _this.localize("QuintaFeira"), "key": "quinta-feira" },
                { "header": _this.localize("SextaFeira"), "key": "sexta-feira" },
                { "header": _this.localize("Sabado"), "key": "sábado" },
                { "header": _this.localize("Domingo"), "key": "domingo" }
            ];
        };
        _this.getItem = function (serventiaId) { return __awaiter(_this, void 0, void 0, function () {
            var response, serventiaDetail_1, diasAtendimento_1, selectedGroups, diasAtendimentoStr, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, serventias_api_1.getServentia(serventiaId)];
                    case 1:
                        response = _a.sent();
                        serventiaDetail_1 = response.data;
                        diasAtendimento_1 = [];
                        selectedGroups = this.makeDropdownItems(this.state.groups);
                        if (serventiaDetail_1.horarioAtendimentoDias) {
                            if (serventiaDetail_1.horarioAtendimentoDias.length > 0) {
                                diasAtendimentoStr = serventiaDetail_1.horarioAtendimentoDias.split(',');
                                diasAtendimentoStr.forEach(function (item) {
                                    _this.getDaysOfWeek().filter(function (day) {
                                        if (item.trim() == day.key) {
                                            diasAtendimento_1.push(day);
                                        }
                                    });
                                });
                            }
                        }
                        if (serventiaDetail_1) {
                            this.setState({
                                ancora: serventiaDetail_1.Ancora,
                                rowKey: serventiaDetail_1.rowKey,
                                partitionKey: serventiaDetail_1.partitionKey,
                                title: serventiaDetail_1.name,
                                descricao: serventiaDetail_1.descricao,
                                secaoJudiciaria: serventiaDetail_1.secaoJudiciaria,
                                diasAtendimento: diasAtendimento_1,
                                horarioAtendimentoInicial: serventiaDetail_1.horarioAtendimentoInicial,
                                horarioAtendimentoFinal: serventiaDetail_1.horarioAtendimentoFinal,
                                //meetingUrl: serventiaDetail.meetingJoinUrl,
                                bookingsUrl: serventiaDetail_1.bookingsUrl,
                                active: !serventiaDetail_1.deleted,
                                listAssuntos: serventiaDetail_1.assuntos,
                                loader: false,
                                queueLimit: serventiaDetail_1.queueLimit,
                                queueLimitData: serventiaDetail_1.queueLimit,
                                activeQueueLimit: !!serventiaDetail_1.queueLimit,
                                selectedAtendentes: selectedGroups.filter(function (g) { return g.key == serventiaDetail_1.permissionGroupId; }),
                                selectedAtendentesId: serventiaDetail_1.permissionGroupId,
                            });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, error_1];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.onTitleChanged = function (event) {
            _this.setState({
                title: event.target.value,
            });
        };
        _this.onDescricaoChanged = function (event) {
            _this.setState({
                descricao: event.target.value,
            });
        };
        _this.onAssuntoChange = function (event) {
            _this.setState({
                assunto: event.target.value,
            });
        };
        _this.addAssunto = function (assunto) {
            var assuntos = _this.state.listAssuntos || [];
            assuntos.push(assunto);
            _this.setState({
                listAssuntos: assuntos,
                assunto: "",
            });
        };
        _this.deleteAssunto = function (assunto, index) {
            var indexAssunto = _this.state.listAssuntos.indexOf(assunto);
            if (indexAssunto > -1) {
                _this.state.listAssuntos.splice(indexAssunto, 1);
            }
            _this.setState({
                listAssuntos: _this.state.listAssuntos
            });
        };
        _this.onTipoCategoriaChanged = function (event, itemsData) {
            _this.setState({
                secaoJudiciaria: itemsData.value,
            });
        };
        _this.onBookingsUrlChanged = function (event) {
            var isValidBookingsUrl = true;
            if (event.target.value) {
                isValidBookingsUrl = common_helper_1.CommonHelper.validUrl(event.target.value);
            }
            else {
                isValidBookingsUrl = true;
            }
            _this.setState({
                bookingsUrl: event.target.value,
                isValidBookingsUrl: isValidBookingsUrl,
            });
        };
        _this.copyEnderecoPublicoToClipboard = function () {
            var el = document.createElement('input');
            el.style.position = 'fixed';
            el.style.left = '0';
            el.style.top = '0';
            el.style.opacity = '0';
            el.value = window.location.origin + "/meeting/" + _this.state.ancora;
            document.body.appendChild(el);
            el.focus();
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
        };
        _this.onHorarioInicialChange = function (event, itemData) {
            var isValidHorario = true;
            var isValidHorarioInicial = true;
            if (itemData.value && _this.state.horarioAtendimentoFinal) {
                var horarioInicial = itemData.value.replace(":", "");
                var horarioFinal = _this.state.horarioAtendimentoFinal.replace(":", "");
                if (Number(horarioInicial) >= Number(horarioFinal)) {
                    isValidHorarioInicial = false;
                }
                else {
                    isValidHorarioInicial = true;
                    _this.setState({ isValidHorarioFinal: true });
                }
            }
            else if (itemData.value) {
                isValidHorario = false;
            }
            _this.setState({
                horarioAtendimentoInicial: itemData.value,
                isValidHorarioInicial: isValidHorarioInicial,
                isValidHorario: isValidHorario
            });
        };
        _this.onHorarioFinalChange = function (event, itemData) {
            var isValidHorario = true;
            var isValidHorarioFinal = true;
            if (itemData.value && _this.state.horarioAtendimentoInicial) {
                var horarioFinal = itemData.value.replace(":", "");
                var horarioInicial = _this.state.horarioAtendimentoInicial.replace(":", "");
                if (Number(horarioInicial) >= Number(horarioFinal)) {
                    isValidHorarioFinal = false;
                }
                else {
                    isValidHorarioFinal = true;
                    _this.setState({ isValidHorarioInicial: true });
                }
            }
            else if (itemData.value) {
                isValidHorario = false;
            }
            _this.setState({
                horarioAtendimentoFinal: itemData.value,
                isValidHorarioFinal: isValidHorarioFinal,
                isValidHorario: isValidHorario
            });
        };
        _this.onDiasAtendimentoChange = function (event, itemsData) {
            _this.setState({
                diasAtendimento: itemsData.value
            });
        };
        _this.isSaveBtnDisabled = function () {
            var title = _this.state.title;
            //const secaoJudiciaria = this.state.secaoJudiciaria;
            //const meetingUrl = this.state.meetingUrl;
            return !(title && _this.state.isValidBookingsUrl && _this.state.isValidHorarioInicial && _this.state.isValidHorarioFinal && _this.state.isValidHorario);
        };
        _this.onSave = function () {
            var _a;
            var diasAtendimento = "";
            (_a = _this.state.diasAtendimento) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                if (diasAtendimento) {
                    diasAtendimento += ", " + item.key;
                }
                else {
                    diasAtendimento = item.key;
                }
            });
            var serventia = {
                ancora: _this.state.ancora,
                rowKey: _this.state.rowKey,
                partitionKey: _this.state.partitionKey,
                name: _this.state.title,
                descricao: _this.state.descricao,
                secaoJudiciaria: _this.state.secaoJudiciaria,
                //meetingJoinUrl: this.state.meetingUrl,
                bookingsUrl: _this.state.bookingsUrl,
                deleted: !_this.state.active,
                horarioAtendimentoInicial: _this.state.horarioAtendimentoInicial,
                horarioAtendimentoFinal: _this.state.horarioAtendimentoFinal,
                horarioAtendimentoDias: diasAtendimento,
                assuntos: _this.state.listAssuntos,
                queueLimit: _this.state.queueLimit,
                permissionGroupId: _this.state.selectedAtendentesId == "" ? null : _this.state.selectedAtendentesId,
            };
            _this.postServentia(serventia).then(function (response) {
                if (response.data == "Unidade existente" && !_this.state.savedNewItem) {
                    _this.setState({
                        isValidAncora: false
                    });
                }
                else {
                    if (!_this.state.isEdit) {
                        _this.setState({
                            savedNewItem: true,
                            ancora: response.data.Ancora,
                            title: response.data.name,
                            partitionKey: response.data.partitionKey,
                            rowKey: response.data.rowKey,
                        });
                    }
                    else {
                        microsoftTeams.tasks.submitTask();
                    }
                }
            });
        };
        _this.onEdit = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({
                    isEdit: true,
                });
                microsoftTeams.tasks.updateTask({ width: 750, height: 650 });
                return [2 /*return*/];
            });
        }); };
        _this.postServentia = function (serventia) { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, serventias_api_1.createOrUpdateServentia(serventia)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_2 = _a.sent();
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.toggleDeleteItem = function (event, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({
                    active: data.checked,
                });
                return [2 /*return*/];
            });
        }); };
        _this.toggleLimite = function (event, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({
                    activeQueueLimit: data.checked,
                    queueLimit: data.checked ? 50 : this.state.queueLimitData,
                });
                if (!data.checked) {
                    this.setState({
                        queueLimitData: 0,
                        queueLimit: 0,
                    });
                }
                return [2 /*return*/];
            });
        }); };
        _this.changeQueueLimit = function (e, data) {
            _this.setState({
                queueLimit: data.value
            });
        };
        _this.getGroupData = function (ancora) { return __awaiter(_this, void 0, void 0, function () {
            var response, responseSettingsGroups, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, config_api_1.getUserGroups()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, serventias_api_1.getGroups(ancora)];
                    case 2:
                        responseSettingsGroups = _a.sent();
                        if (response.data && responseSettingsGroups.data) {
                            this.setState({
                                groups: _.uniqBy(response.data.concat(responseSettingsGroups.data), 'id'),
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        return [2 /*return*/, error_3];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onGroupSearch = function (itemList, searchQuery) {
            var result = itemList.filter(function (item) { return (item.header && item.header.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1) ||
                (item.content && item.content.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1); });
            return result;
        };
        _this.makeDropdownItems = function (items) {
            var resultedTeams = [];
            if (items) {
                items.forEach(function (element) {
                    resultedTeams.push({
                        key: element.id,
                        header: element.displayName,
                        content: element.mail,
                        image: image_helper_1.ImageUtil.makeInitialImage(element.displayName),
                        team: {
                            id: element.id
                        },
                    });
                });
            }
            return resultedTeams;
        };
        _this.onGroupSearchQueryChange = function (event, itemsData) { return __awaiter(_this, void 0, void 0, function () {
            var result, query, response, error_4, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!itemsData.searchQuery) return [3 /*break*/, 1];
                        this.setState({
                            noResultMessage: "",
                        });
                        return [3 /*break*/, 6];
                    case 1:
                        if (!(itemsData.searchQuery && itemsData.searchQuery.length <= 2)) return [3 /*break*/, 2];
                        this.setState({
                            loading: false,
                            noResultMessage: this.localize("NenhumaOcorrencia"),
                        });
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(itemsData.searchQuery && itemsData.searchQuery.length > 2)) return [3 /*break*/, 6];
                        result = itemsData.items && itemsData.items.find(function (item) { return item.header.toLowerCase() === itemsData.searchQuery.toLowerCase(); });
                        if (result) {
                            return [2 /*return*/];
                        }
                        this.setState({
                            loading: true,
                            noResultMessage: "",
                        });
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        query = encodeURIComponent(itemsData.searchQuery);
                        return [4 /*yield*/, config_api_1.searchGroups(query)];
                    case 4:
                        response = _a.sent();
                        this.setState({
                            groups: response.data,
                            loading: false,
                            noResultMessage: this.localize("NenhumaOcorrencia"),
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        error_4 = _a.sent();
                        return [2 /*return*/, error_4];
                    case 6:
                        if (!(itemsData.searchQuery.length == 0)) return [3 /*break*/, 8];
                        return [4 /*yield*/, config_api_1.getUserGroups()];
                    case 7:
                        response = _a.sent();
                        this.setState({
                            groups: response.data,
                            loading: false,
                        });
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        _this.onAtendentesChange = function (event, itemsData) {
            if (itemsData.value.length > 1)
                _this.setState({
                    selectedAtendentes: itemsData.value[1],
                    selectedAtendentesId: itemsData.value[1].key,
                });
            else
                _this.setState({
                    selectedAtendentes: itemsData.value[0],
                    selectedAtendentesId: (itemsData === null || itemsData === void 0 ? void 0 : itemsData.value.length) ? itemsData.value[0].key : "",
                });
        };
        _this.localize = _this.props.t;
        Icons_1.initializeIcons();
        _this.state = {
            ancora: "",
            rowKey: "",
            partitionKey: "",
            title: "",
            descricao: "",
            assunto: "",
            listAssuntos: [],
            secaoJudiciaria: "",
            //meetingUrl: "",
            bookingsUrl: "",
            active: true,
            horarioAtendimentoInicial: "",
            horarioAtendimentoFinal: "",
            diasAtendimento: [],
            itemsTiposCategorias: [],
            loader: true,
            loading: false,
            isEdit: false,
            isValidBookingsUrl: true,
            isValidHorarioInicial: true,
            isValidHorarioFinal: true,
            isValidHorario: true,
            isValidAncora: true,
            activeQueueLimit: false,
            queueLimit: 0,
            queueLimitData: 0,
            groups: [],
            selectedAtendentes: [],
            selectedAtendentesId: "",
            noResultMessage: "",
            savedNewItem: false,
            selectedMenu: 0,
        };
        return _this;
    }
    FormBalcaoVirtual.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, id_1;
            var _this = this;
            return __generator(this, function (_a) {
                microsoftTeams.initialize();
                this.getTiposCategorias();
                params = this.props.match.params;
                if ('id' in params) {
                    id_1 = params['id'];
                    this.getGroupData(id_1).then(function (graphData) {
                        _this.getItem(id_1);
                    });
                    this.setState({
                        isEdit: true
                    });
                }
                else {
                    this.setState({
                        loader: false,
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    FormBalcaoVirtual.prototype.renderAssuntos = function (item, index) {
        var _this = this;
        return {
            key: index,
            className: 'item-assunto',
            header: item,
            truncateHeader: true,
            endMedia: (React.createElement(react_icons_northstar_1.CloseIcon, { circular: true, size: "small", styles: { cursor: 'pointer' }, onClick: function () { return _this.deleteAssunto(item, index); } }))
        };
    };
    FormBalcaoVirtual.prototype.onCancel = function () {
        microsoftTeams.tasks.submitTask();
    };
    FormBalcaoVirtual.prototype.getTiposCategorias = function () {
        var _this = this;
        config_api_1.getAppSettingsTipoCategoria().then(function (settingsData) {
            _this.setState({
                itemsTiposCategorias: settingsData.data.tiposCategorias ? settingsData.data.tiposCategorias : []
            });
        });
    };
    FormBalcaoVirtual.prototype.getGroupItems = function () {
        if (this.state.groups) {
            return this.makeDropdownItems(this.state.groups);
        }
        var dropdownItems = [];
        return dropdownItems;
    };
    FormBalcaoVirtual.prototype.setActiveTabId = function (index, item) {
        this.setState({
            selectedMenu: index
        });
    };
    FormBalcaoVirtual.prototype.render = function () {
        var _this = this;
        if (this.state.loader) {
            return (React.createElement(loaderFormBalcaoVirtual_1.default, null));
        }
        else {
            if (!this.state.isEdit) {
                return (React.createElement("div", { className: "taskModule" },
                    React.createElement("div", { className: "formContainer" },
                        React.createElement("div", { className: "formContentContainer" },
                            !this.state.savedNewItem &&
                                React.createElement(react_northstar_1.Flex, { column: true },
                                    React.createElement("div", { className: "inputField form-section" },
                                        React.createElement(react_northstar_1.Text, { weight: "bold", content: this.localize("VamosComecar") + "!" })),
                                    React.createElement(react_northstar_1.Input, { className: "inputField", fluid: true, value: this.state.title, label: this.localize("QualNomeUnidade") + "?", onChange: this.onTitleChanged, error: this.state.title != '' && !this.state.isValidAncora, errorIndicator: React.createElement(react_northstar_1.Tooltip, { content: this.localize("UnidadeExistente") },
                                            React.createElement(react_icons_northstar_1.ExclamationCircleIcon, null)), required: true }),
                                    React.createElement(react_northstar_1.Flex, { hAlign: "center", gap: "gap.medium", vAlign: "center" },
                                        React.createElement(react_northstar_1.Box, { className: "build" },
                                            React.createElement(react_northstar_1.Image, { src: "images/build.svg" })))),
                            this.state.savedNewItem &&
                                React.createElement(react_northstar_1.Flex, { hAlign: "center", vAlign: "center", gap: "gap.medium", column: true },
                                    React.createElement(react_northstar_1.Text, { className: "inputField", content: this.localize("UnidadeCriada") + "!" }),
                                    React.createElement(react_northstar_1.Box, { className: "done" },
                                        React.createElement(react_northstar_1.Image, { src: "images/done.svg" }))))),
                    React.createElement("div", { className: "footerContainer" },
                        React.createElement("div", { className: "buttonContainer" }, !this.state.savedNewItem ?
                            React.createElement(react_northstar_1.Button, { content: this.localize("Salvar"), id: "saveBtn", onClick: this.onSave, primary: true, disabled: this.isSaveBtnDisabled() })
                            :
                                React.createElement(react_northstar_1.Button, { content: this.localize("Personalizar"), id: "saveBtn", onClick: this.onEdit, primary: true })))));
            }
            else {
                return (React.createElement("div", { className: "taskModule" },
                    React.createElement("div", { className: "formContainer" },
                        React.createElement(react_northstar_1.Flex, { gap: "gap.medium", padding: "padding.medium" },
                            React.createElement(react_northstar_1.Flex.Item, { size: "medium" },
                                React.createElement(react_northstar_1.Flex, { className: "settings-menu", gap: "gap.small", column: true },
                                    React.createElement(react_northstar_1.Menu, { activeIndex: this.state.selectedMenu, onItemClick: function (currentTarget, props) {
                                            return _this.setActiveTabId(props && props.index ? props.index : 0, props);
                                        }, items: [
                                            {
                                                icon: (React.createElement(react_icons_northstar_1.InfoIcon, { outline: true })),
                                                key: 'geral',
                                                content: this.localize("Geral"),
                                            },
                                            {
                                                icon: (React.createElement(react_icons_northstar_1.ShieldKeyholeIcon, { outline: true })),
                                                key: 'acesso',
                                                content: this.localize("ControleAcesso"),
                                            },
                                            {
                                                icon: (React.createElement(react_icons_northstar_1.CalendarIcon, { outline: true })),
                                                key: 'horario',
                                                content: this.localize("HorarioComercial"),
                                            },
                                            {
                                                icon: (React.createElement(react_icons_northstar_1.SettingsIcon, { outline: true })),
                                                key: 'avancado',
                                                content: this.localize("Avancado"),
                                            },
                                        ], vertical: true }))),
                            React.createElement(react_northstar_1.Flex.Item, { grow: true },
                                React.createElement("div", { className: "formContentContainer" },
                                    this.state.selectedMenu == 0 &&
                                        React.createElement(React.Fragment, null,
                                            React.createElement(react_northstar_1.Flex, null,
                                                React.createElement(react_northstar_1.Input, { className: "inputField", fluid: true, value: this.state.title, label: this.localize("NomeUnidade"), onChange: this.onTitleChanged, error: this.state.title != '' && !this.state.isValidAncora, errorIndicator: React.createElement(react_northstar_1.Tooltip, { content: this.localize("UnidadeExistente") },
                                                        React.createElement(react_icons_northstar_1.ExclamationCircleIcon, null)), required: true }),
                                                React.createElement("div", { className: "inputField", style: { padding: "0 3.2rem 0 0" } },
                                                    React.createElement(react_northstar_1.Text, { className: "label-field", content: this.localize("Ativo") }),
                                                    React.createElement(react_northstar_1.Checkbox, { styles: { paddingLeft: "0px" }, checked: this.state.active, onChange: this.toggleDeleteItem, toggle: true }))),
                                            React.createElement("div", { className: "inputField" },
                                                React.createElement(react_northstar_1.Text, { className: "label-field", content: this.localize("Descricao") }),
                                                React.createElement(react_northstar_1.TextArea, { variables: {
                                                        height: "120px"
                                                    }, fluid: true, value: this.state.descricao, onChange: this.onDescricaoChanged, required: true, maxLength: 1024 })),
                                            React.createElement("div", { className: "inputField" },
                                                React.createElement(react_northstar_1.Text, { className: "label-field", content: this.localize("Categoria") }),
                                                React.createElement(react_northstar_1.Dropdown, { items: this.state.itemsTiposCategorias, fluid: true, clearable: true, checkable: true, placeholder: this.localize("SelecioneCategoria"), onChange: this.onTipoCategoriaChanged, value: this.state.secaoJudiciaria })),
                                            this.state.ancora &&
                                                React.createElement(react_northstar_1.Input, { hidden: !this.state.isEdit, icon: React.createElement(react_icons_northstar_1.WindowRestoreIcon, { onClick: this.copyEnderecoPublicoToClipboard, styles: { cursor: 'pointer' } }), className: "inputField endereco-publico", fluid: true, value: window.location.origin + "/meeting/" + this.state.ancora, label: this.localize("EnderecoPublico"), readOnly: true, disabled: true })),
                                    this.state.selectedMenu == 1 &&
                                        React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "inputField permission" },
                                                React.createElement(react_northstar_1.Text, { className: "label-field", content: this.localize("Atendentes") }),
                                                React.createElement(react_northstar_1.Dropdown, { multiple: true, fluid: true, className: "hideToggle", placeholder: this.localize("GrupoM365"), search: this.onGroupSearch, loading: this.state.loading, loadingMessage: this.localize("Carregando"), items: this.getGroupItems(), value: this.state.selectedAtendentes, onSearchQueryChange: this.onGroupSearchQueryChange, onChange: this.onAtendentesChange, noResultsMessage: this.state.noResultMessage, unstable_pinned: true }))),
                                    this.state.selectedMenu == 2 &&
                                        React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "inputField diasAtendimento" },
                                                React.createElement(react_northstar_1.Text, { className: "label-field", content: this.localize("DiasAtendimento") }),
                                                React.createElement(react_northstar_1.Dropdown, { multiple: true, fluid: true, clearable: true, checkable: true, items: this.getDaysOfWeek(), placeholder: this.localize("SelecioneDiasAtendimento"), onChange: this.onDiasAtendimentoChange, value: this.state.diasAtendimento })),
                                            React.createElement(react_northstar_1.Flex, null,
                                                React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                                    React.createElement("div", { className: "inputField" },
                                                        React.createElement(react_northstar_1.Text, { className: "label-field", content: this.localize("HorariosAtendimento") }),
                                                        React.createElement(react_northstar_1.Dropdown, { items: data_1.default.hoursStart, fluid: true, clearable: true, checkable: true, placeholder: this.localize("HorarioInicial"), onChange: this.onHorarioInicialChange, value: this.state.horarioAtendimentoInicial, error: this.state.horarioAtendimentoInicial != '' && !this.state.isValidHorarioInicial }))),
                                                React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                                    React.createElement("div", { className: "inputField" },
                                                        React.createElement(react_northstar_1.Text, { className: "label-field", styles: { height: "18px" } }),
                                                        React.createElement(react_northstar_1.Dropdown, { items: data_1.default.hoursEnd, fluid: true, clearable: true, checkable: true, placeholder: this.localize("HorarioFinal"), onChange: this.onHorarioFinalChange, value: this.state.horarioAtendimentoFinal, error: this.state.horarioAtendimentoFinal != '' && !this.state.isValidHorarioFinal }))))),
                                    this.state.selectedMenu == 3 &&
                                        React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "inputField form-section" },
                                                React.createElement(react_northstar_1.Text, { weight: "bold", content: this.localize("ControleFila") })),
                                            React.createElement("div", { className: "inputField" },
                                                React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", column: true },
                                                    React.createElement(react_northstar_1.Flex, { vAlign: "center", gap: "gap.large" },
                                                        React.createElement(react_northstar_1.Text, { className: "label-field limite", content: this.localize("LimiteSolicitacoesSimultaneas") }),
                                                        React.createElement(react_northstar_1.Checkbox, { styles: { margin: "10px 0 0 8px" }, checked: !!this.state.activeQueueLimit, onChange: this.toggleLimite, toggle: true })),
                                                    React.createElement(react_northstar_1.Flex, { vAlign: "center", gap: "gap.large" },
                                                        React.createElement(react_northstar_1.FlexItem, null,
                                                            React.createElement(react_northstar_1.Slider, { fluid: true, min: 0, max: 100, vertical: false, value: this.state.queueLimit, onChange: this.changeQueueLimit, hidden: !this.state.activeQueueLimit })),
                                                        React.createElement(react_northstar_1.FlexItem, { size: "size.small" },
                                                            React.createElement(react_northstar_1.Input, { icon: React.createElement(react_icons_northstar_1.SpeakerPersonIcon, null), iconPosition: "start", className: "pessoasFila", type: "number", fluid: true, min: 0, max: 100, disabled: true, value: this.state.queueLimit, onChange: this.changeQueueLimit, hidden: !this.state.activeQueueLimit }))))),
                                            React.createElement("div", { className: "inputField form-section not-first" },
                                                React.createElement(react_northstar_1.Text, { weight: "bold", content: this.localize("IntegracaoBookings") })),
                                            React.createElement(react_northstar_1.Input, { className: "inputField", fluid: true, value: this.state.bookingsUrl, label: this.localize("EnderecoAgenda"), onChange: this.onBookingsUrlChanged, error: this.state.bookingsUrl != '' && !this.state.isValidBookingsUrl, errorIndicator: React.createElement(react_northstar_1.Tooltip, { content: this.localize("URLInvalida") },
                                                    React.createElement(react_icons_northstar_1.ExclamationCircleIcon, null)) }),
                                            React.createElement("div", { className: "inputField form-section not-first" },
                                                React.createElement(react_northstar_1.Text, { weight: "bold", content: this.localize("TagsSolicitacao") })),
                                            React.createElement("div", { className: "inputField" },
                                                React.createElement(react_northstar_1.Text, { className: "label-field", content: this.localize("TagsDisponiveis") }),
                                                React.createElement(react_northstar_1.Input, { icon: this.state.assunto ? React.createElement(react_icons_northstar_1.AddIcon, { styles: { cursor: "pointer" }, onClick: function () { return _this.addAssunto(_this.state.assunto); } }) : React.createElement(React.Fragment, null), fluid: true, value: this.state.assunto, onChange: this.onAssuntoChange })),
                                            React.createElement("div", { className: "inputField" },
                                                React.createElement(react_northstar_1.List, { items: this.state.listAssuntos ? this.state.listAssuntos.map(this.renderAssuntos.bind(this)) : [] }))))))),
                    React.createElement("div", { className: "footerContainer" },
                        React.createElement("div", { className: "buttonContainer" },
                            React.createElement(react_northstar_1.Button, { content: this.localize("Cancelar"), id: "cancelBtn", onClick: this.onCancel }),
                            React.createElement(react_northstar_1.Button, { content: this.localize("Salvar"), id: "saveBtn", onClick: this.onSave, primary: true, disabled: this.isSaveBtnDisabled() })))));
            }
        }
    };
    FormBalcaoVirtual.prototype.escFunction = function (event) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            microsoftTeams.tasks.submitTask();
        }
    };
    return FormBalcaoVirtual;
}(React.Component));
var formBalcaoVirtualWithTranslation = react_i18next_1.withTranslation()(FormBalcaoVirtual);
exports.default = formBalcaoVirtualWithTranslation;
//# sourceMappingURL=form-balcao-virtual.js.map